import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, provide, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import {
  IWithdrawReview,
  IWithdrawConclusion,
  IWithdrawDetailsV2,
  getWithdrawDetailsV2,
  makeProductWithdraw,
  getProductWithdrawReview
} from '@/modules/transaction/services/product-withdraw';
import { isBFFError } from '@/modules/common/helpers/bff';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { ProductWithdrawComponents, EProductWithdrawSteps } from './helpers';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductWithdraw',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isOnGoingRedemptionsActive = computed(() => {
  return FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_ON_GOING_REDEMPTIONS);
});

const currentStep = ref(
  isOnGoingRedemptionsActive.value
    ? EProductWithdrawSteps.WITHDRAWV2
    : EProductWithdrawSteps.WITHDRAW
);
const withdrawDetails = ref<IWithdrawDetailsV2>();
const withdrawReview = ref<IWithdrawReview>();
const withdrawConclusion = ref<IWithdrawConclusion>();

const isLoading = ref(true);
const isFetchingReview = ref(false);
const isFetchingWithdraw = ref(false);
const hasError = ref(false);
const amount = ref(0);

const step = computed(() => {
  return {
    component: ProductWithdrawComponents[currentStep.value]
  };
});

const showNavbar = computed(() => {
  return currentStep.value !== EProductWithdrawSteps.CONCLUSION;
});

const productId = computed(() => {
  const { id } = route.params;

  return id;
});

const categoryId = computed(() => {
  const { type } = route.params;

  return type;
});

function onBack() {
  if (
    currentStep.value === EProductWithdrawSteps.WITHDRAW ||
    currentStep.value === EProductWithdrawSteps.WITHDRAWV2
  )
    return onClose();

  currentStep.value = currentStep.value - 1;
}

function onClose() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    router.push({
      name: 'productsCatalog',
      params: {
        type: route.params.type || 'fixed-income'
      }
    });
  }
}

async function fetchWithdrawDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    withdrawDetails.value = await getWithdrawDetailsV2(
      productId.value,
      categoryId.value
    );
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchWithdrawReview(amountValue: number) {
  amount.value = amountValue;

  try {
    isFetchingReview.value = true;

    withdrawReview.value = await getProductWithdrawReview(
      productId.value,
      amount.value
    );

    currentStep.value = EProductWithdrawSteps.REVIEW;
  } catch (e) {
    let errorMessage =
      'Não foi possível realizar a operação, por favor tente novamente.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isFetchingReview.value = false;
  }
}

async function fetchWithdraw() {
  try {
    isFetchingWithdraw.value = true;

    withdrawConclusion.value = await makeProductWithdraw(
      productId.value,
      amount.value
    );

    currentStep.value = EProductWithdrawSteps.CONCLUSION;
  } catch (e) {
    let errorMessage =
      'Não foi possível realizar a operação, por favor tente novamente.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isFetchingWithdraw.value = false;
  }
}

onMounted(() => fetchWithdrawDetails());

provide('withdrawDetails', withdrawDetails);
provide('withdrawReview', withdrawReview);
provide('withdrawConclusion', withdrawConclusion);
provide('isFetchingReview', isFetchingReview);
provide('isFetchingWithdraw', isFetchingWithdraw);
provide('productId', productId);

provide('fetchWithdrawReview', fetchWithdrawReview);
provide('fetchWithdraw', fetchWithdraw);

return { __sfc: true,route, router, isOnGoingRedemptionsActive, currentStep, withdrawDetails, withdrawReview, withdrawConclusion, isLoading, isFetchingReview, isFetchingWithdraw, hasError, amount, step, showNavbar, productId, categoryId, onBack, onClose, fetchWithdrawDetails, fetchWithdrawReview, fetchWithdraw, NavBar, LoaderIndicator, HelperViewStatus, BackButton, FadeTransition }
}

})